<div class="card">
    <button pButton pRipple type="button" [disabled]="permissaoService.can('modelo_email_salvar') == false"
        class="flex mb-2" label="Salvar" (click)="save()"></button>

    <p-editor [(ngModel)]="text" [style]="{'height':'320px'}"></p-editor>
</div>
